import React from 'react';
import moment from 'moment';
import { useMediaQuery } from 'react-responsive';

import { daysList } from '../../../config/dateConfig';
import { CalendarItemProps } from '../models/calendarModels';
import CalendlyEventButton from './CalendlyEventButton';

const CalendarItem: React.FC<CalendarItemProps> = ({
  year,
  month,
  isLoading,
  calendlyEventsData,
}) => {
  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  const getDaysArrayForMonth = (year: number, month: number) => {
    const firstDayOfMonth = moment([year, month, 1]);
    const daysInMonth = firstDayOfMonth.daysInMonth();
    const firstDayOfWeek = firstDayOfMonth.day();

    // Adjust if the first day of the week is Sunday
    const startPadding = firstDayOfWeek === 0 ? 6 : firstDayOfWeek - 1;

    const daysArray: moment.Moment[] = [];

    // Add empty days for the beginning of the month

    for (let i = 0; i < startPadding; i++) {
      daysArray.push(moment.invalid());
    }

    // Add all days in the current month
    for (let i = 1; i <= daysInMonth; i++) {
      daysArray.push(moment([year, month, i]));
    }

    // Calculate padding for the end of the month to fill the last week
    const endPadding = 7 - (daysArray.length % 7);
    for (let i = 0; i < endPadding; i++) {
      daysArray.push(moment.invalid());
    }

    return daysArray;
  };

  const daysArray = getDaysArrayForMonth(year, month);

  const renderDaysOfWeek = () => {
    return (
      <div className="d-flex-row w-100">
        {daysList.map((day) => (
          <div
            key={day}
            className={`${isMobile ? 'mb-1rem' : 'mb-1_5rem'} d-flex-center w-14_28 `}
          >
            <span className="ff-arial fw-400 fs-1_125rem">{day}</span>
          </div>
        ))}
      </div>
    );
  };

  const renderCalendar = (daysArray: moment.Moment[]) => {
    const weeks: any = [];
    let week: JSX.Element[] = [];
    const currentDate = moment();

    daysArray.forEach((day, index) => {
      const isCurrentDate = day.isSame(currentDate, 'day');
      if (day.isValid()) {
        week.push(
          <CalendlyEventButton
            key={index}
            day={day}
            month={month}
            calendlyEventsData={calendlyEventsData}
            isLoading={isLoading ?? false}
            isCurrentDate={isCurrentDate}
          />
        );
      } else {
        week.push(
          <div
            key={`empty-${index}`}
            className="d-flex-center w-14_28 h-7rem"
          ></div>
        );
      }

      if ((index + 1) % 7 === 0 || index === daysArray.length - 1) {
        weeks.push(
          <div key={index / 7} className="d-flex-row w-100">
            {week}
          </div>
        );
        week = [];
      }
    });

    return weeks;
  };

  return (
    <>
      <div className="d-flex-row w-100 ">{renderDaysOfWeek()}</div>
      {renderCalendar(daysArray)}
    </>
  );
};

export default CalendarItem;
